/* eslint-disable */
// src/layouts/localDesechos/index.js

import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import AppFormDialog from "components/common/AppFormDialog";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import LocalMachineTable from "layouts/localDepositoDesechos/LocalMachineTable";
import localService from "services/localService";
import localDesechosTableData from "./data/localDesechosTableData";
import CreateLocalDesechosForm from "../../forms/local/localDepositoDesechos/createLocalDesechosForm";
import UpdateLocalForm from "../../forms/local/updateLocalForm";

function LocalDesechos() {
  const location = useLocation();
  const navigate = useNavigate();

  const [localsDetails, setLocalsDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [query, setQuery] = useState("");

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [localToEdit, setLocalToEdit] = useState(null);

const load = useCallback(async () => {
    let cancelled = false;
    setIsLoading(true);
    try {
      const data = await localService.getActiveLocalDesechosMachines();
      if (cancelled) return;
      setLocalsDetails(data || []);
    } finally {
      if (!cancelled) setIsLoading(false);
    }
    return () => {
      cancelled = true;
    };
  }, []);

  // refresca cada vez que entrás a la página (navegación)
  useEffect(() => {
    load();
  }, [load, location.key]);

  // refresca al volver al tab/ventana (sin botón)
  useEffect(() => {
    const onFocus = () => load();
    const onVisibility = () => {
      if (document.visibilityState === "visible") load();
    };

    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [load]);

  const handleOpenCreateModal = () => setIsCreateModalOpen(true);
  const handleCloseCreateModal = () => setIsCreateModalOpen(false);

  const handleOpenEditModal = (localId) => {
    const local = localsDetails.find((l) => l.Id === localId);
    if (!local) return;
    setLocalToEdit(local);
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setLocalToEdit(null);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Bajas
                </MDTypography>

                <MDBox display="flex" gap={1}>
                  <Button color="inherit" onClick={handleOpenCreateModal}>
                    Nuevo tipo de baja
                  </Button>
                  <Button
                    color="inherit"
                    onClick={() => navigate("/localDeposito")}
                  >
                    Volver a depósitos
                  </Button>
                </MDBox>
              </MDBox>

              <MDBox pt={3} px={3} pb={2} display="flex" justifyContent="flex-end">
                <TextField
                  label="Buscar por máquina, serie, tipo"
                  value={query}
                  size="small"
                  onChange={(event) => setQuery(event.target.value)}
                  sx={{
                    width: { xs: "100%", sm: 340 },
                    maxWidth: "100%",
                    "& .MuiOutlinedInput-root": { backgroundColor: "#fff" },
                  }}
                />
              </MDBox>

              <MDBox px={2} pb={3}>
                {(localsDetails || []).map((local) => (
                    <LocalMachineTable
                      key={local.Id}
                      local={local}
                      query={query}
                      isLoading={isLoading}
                      makeTable={(machines) => localDesechosTableData({ machines })}
                      actions={
                        <IconButton
                          name="updateDesechos"
                          aria-label="editar tipo de baja"
                          color="primary"
                          onClick={() => handleOpenEditModal(local.Id)}
                        >
                          <DriveFileRenameOutlineIcon />
                        </IconButton>
                      }
                    />
                ))}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <AppFormDialog open={isCreateModalOpen} onClose={handleCloseCreateModal} title="Nuevo tipo de baja">
          <CreateLocalDesechosForm
          closeForm={handleCloseCreateModal}
          onCreated={load}
          />
      </AppFormDialog>

      {localToEdit && (
        <AppFormDialog
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          title={localToEdit.Name ? `Editar tipo de baja ${localToEdit.Name}` : "Editar tipo de baja"}
          maxWidth="md"
        >
            <UpdateLocalForm
              closeForm={async () => {
                handleCloseEditModal();
                await load();
              }}
              local={localToEdit}
              entityName="tipo de baja"
            />
        </AppFormDialog>
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default LocalDesechos;
